// Header Data

export const billHeaderColumns = ({
  dataToPut,
  customerDetails,
  userData,
  billNumber,
}) => {
  const columnOne = [
    { label: 'customer', value: `${customerDetails?.ledgerName || ''}` },
    { label: 'address', value: `${customerDetails?.ledgerAddress || ''}` },
    {
      label: 'mobile no',
      value: `${customerDetails?.ledgerMobileNumber || ''}`,
    },
    { label: 'pan no', value: `${customerDetails?.ledgerPanNumber || ''}` },
  ];
  const columnTwo = [
    // { label: 'counter', value: 'N/A' },
    { label: 'sales person', value: `${customerDetails?.salesPerson || ''}` },
    { label: 'order no', value: '' },
    { label: 'order miti', value: '' },
  ];
  const columnThree = [
    { label: 'Bill no', value: `${customerDetails?.billNumber || ''}` },
    {
      label: 'invoice date',
      value: `${customerDetails?.invoiceDate || ''}`,
    },
    { label: 'invoice miti', value: `${customerDetails?.invoiceDateInNepali || ''}` },
  ];

  return { columnOne, columnTwo, columnThree };
};

export const companyDetail = ({ userData, date }) => {
  const companyDetails = {
    title: `${userData?.companyName || 'Company Name'}`,
    branchInfo: `${userData?.branchName || 'Company Branch Name'}, ${
      userData?.branchAddress || 'Branch Address'
    }`,
    phone: `+977 ${userData?.companyNumber || 'Phone Number'}`,
    email: `${userData?.companyEmail || 'Email Address'}`,
    pan: `${userData?.companypanNumber || 'Email Address'}`,
    date: date,
  };
  return { companyDetails };
};
